import SvgMask from '../../_Helpers/SvgMask';

interface StatusCellTypes {
	percentage?: number;
	className?: string;
	type?: 'percentage' | 'binary-result' | 'default';
	width?: 'default' | 'small' | 'medium' | 'large';
	customWidth?: number;
	isCorrect?: boolean;
}

const StatusCell: React.FC<StatusCellTypes> = ({
	percentage,
	className,
	type = 'default',
	width = '',
	isCorrect,
	customWidth
}) => {
	const calculateStatus = (percentage: number | undefined) => {
		if (percentage === undefined) return 'unstarted';

		if (percentage <= 25 || percentage === 0) {
			return 'low';
		} else if (percentage > 25 && percentage <= 50) {
			return 'average';
		} else if (percentage > 50 && percentage < 100) {
			return 'high';
		} else if (percentage === 100) {
			return 'complete';
		}
	};

	return type === 'percentage' ? (
		<div
			className={`assessment-status-cell percentage ${className} ${width} ${calculateStatus(percentage)}`}
			// Only apply the styling when the customWidth is provided
			{...(customWidth ? { style: { width: customWidth } } : {})}
		>
			{percentage === 100 ? (
				<div className="tick-icon">
					<SvgMask path={'/svg/check-success.svg'} width={24} height={24} />
				</div>
			) : percentage !== undefined ? (
				<>{Math.round(percentage)}%</>
			) : (
				'-'
			)}
		</div>
	) : type === 'binary-result' ? (
		<div
			className={`assessment-status-cell binary-result ${
				isCorrect || isCorrect === undefined ? '' : 'incorrect'
			} ${className} ${width}`}
			// Only apply the styling when the customWidth is provided
			{...(customWidth ? { style: { width: customWidth } } : {})}
		>
			{isCorrect === true ? (
				<div className="tick-icon">
					<SvgMask path={'/svg/check-success.svg'} width={24} height={24} />
				</div>
			) : isCorrect === false ? (
				<div className="cross-icon">
					<SvgMask path={'/svg/cross-thin.svg'} width={24} height={24} />
				</div>
			) : (
				'-'
			)}
		</div>
	) : type === 'default' ? (
		<div className={`assessment-status-cell ${className} ${width}`}>-</div>
	) : null;
};

export default StatusCell;
